import testIdJson from "./testIdSource.json" with { type: "json" };

interface RecursiveStringRecord {
  [key: string]: string | RecursiveStringRecord;
}

function setPathAsValue<T extends RecursiveStringRecord>(
  obj: T,
  basePath = "",
): T {
  const result = { ...obj };

  for (const key in obj) {
    const newPath = basePath ? `${basePath}.${key}` : key;

    if (obj[key] && typeof obj[key] === "object") {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- fix for weird ts error only in docker build
      result[key] = setPathAsValue(obj[key] as any, newPath);
    } else {
      // @ts-expect-error -- valid path
      result[key] = newPath;
    }
  }

  return result;
}

function mapObjectRecursively<T extends Record<string, unknown>, U>(
  obj: T,
  fn: (value: string, key: string, obj: T) => U,
): T {
  const result = { ...obj };

  for (const key in obj) {
    if (obj[key] && typeof obj[key] === "object") {
      // @ts-expect-error -- valid path
      result[key] = mapObjectRecursively(obj[key] as T, fn);
    } else {
      // @ts-expect-error -- valid path
      result[key] = fn(obj[key] as string, key, obj);
    }
  }

  return result;
}

export const testId = setPathAsValue(testIdJson);
export const testIdSelector = mapObjectRecursively(
  testId,
  (value) => `[data-testid="${value}"]`,
);
